import destroyFns from 'antd/es/modal/destroyFns';
export default destroyFns;
